



















































import Icon from '../../../shared/components/Icon.vue';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import AulaPopover from '../../../shared/components/AulaPopover.vue';
import uniqueId from 'lodash/uniqueId';
import { PropType } from 'vue';
import { CommonInboxModel } from '../../../shared/models/commonInbox.model';
import { portalRoles } from '../../../shared/enums/portalRoles';
export default {
  components: { AulaPopover, Icon },
  props: {
    inbox: { type: Object as PropType<CommonInboxModel>, required: true },
  },
  computed: {
    iconClassEnum() {
      return iconClassEnum;
    },
    buttonId() {
      return uniqueId('messageInbox');
    },
    participantCount() {
      return this.inbox.participants.length;
    },
    children() {
      return this.inbox.participants.filter(participant => participant.mailBoxOwner.portalRole == portalRoles.CHILD);
    },
    guardians() {
      return this.inbox.participants.filter(participant => participant.mailBoxOwner.portalRole == portalRoles.GUARDIAN);
    },
    employees() {
      return this.inbox.participants.filter(participant => participant.mailBoxOwner.portalRole == portalRoles.EMPLOYEE);
    },
    title() {
      return this.$t('label.member_of', { name: this.inbox.name });
    },
  },
};
